(function () {
  var selector = '[data-lucce-band-width]';
  var frame;

  function widths(elements, values) {
    (elements || []).forEach(function (element) {
      if (/^band\s*width(?:\s*\([^)]*\))?\s*$/i.test(element.label || '')) {
        (element.option_values || []).forEach(function (option) {
          var match = String(option.value || '').trim().match(/^(\d+(?:\.\d+)?)\s*mm$/i);
          if (match && Number(match[1]) > 0) values.push(Number(match[1]));
        });
      }
      if (element.elements) widths(element.elements, values);
    });
  }

  function update() {
    frame = null;
    var config = window.GPOConfigs;
    if (!config || !config.productOptionSetMap || !config.options) return;
    document.querySelectorAll(selector).forEach(function (node) {
      var ids = String(config.productOptionSetMap[node.dataset.productId] || '').split(',').filter(Boolean);
      var values = [];
      var ready = ids.every(function (id) { return !!config.options[id]; });
      if (!ready) return;
      ids.forEach(function (id) {
        var set = config.options[id];
        if (set.status || (set.published_scope && !set.published_scope.split(',').includes('web'))) return;
        if (set.countries && set.countries.enable) {
          var included = (set.countries.countries || []).includes(window.Shopify && window.Shopify.country);
          if ((set.countries.type === 'include' && !included) || (set.countries.type === 'exclude' && included)) return;
        }
        widths(set.elements, values);
      });
      var text = '';
      if (values.length) {
        var min = Math.min.apply(null, values);
        var max = Math.max.apply(null, values);
        text = min + 'mm' + (min === max ? '' : '–' + max + 'mm');
      }
      if (node.textContent !== text) node.textContent = text;
      node.hidden = !text;
    });
  }

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(update);
  }

  function init() {
    new MutationObserver(function (records) {
      if (records.some(function (record) {
        return !record.target.closest || !record.target.closest(selector);
      })) schedule();
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['type', 'src'] });
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('asyncLazyLoad', schedule);
    window.addEventListener('load', schedule);
    var attempts = 0;
    var timer = window.setInterval(function () {
      schedule();
      if (++attempts >= 30) window.clearInterval(timer);
    }, 1000);
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
